import type { App } from 'vue'
import {
  MutationCache,
  QueryClient,
  VueQueryPlugin,
  type VueQueryPluginOptions,
} from '@tanstack/vue-query'
import { useToastStore } from '../store'

export function vueQuery(app: App) {
  const toastStore = useToastStore()

  const mutationCache = new MutationCache({
    onSuccess(_, __, ___, { options }) {
      if (options.meta?.noSuccessToast) {
        return
      }

      if (options.meta?.message) {
        toastStore.showSuccessToast(options.meta?.message as string)
        return
      }
    },
    onError(err) {
      const error = err as AxiosCustomError

      if (!error.response) {
        return
      }
    },
  })

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        staleTime: 0,
      },
    },
    mutationCache,
  })

  const options: VueQueryPluginOptions = { queryClient }

  app.use(VueQueryPlugin, options)
}
